if (!customElements.get('vg-premium-edit')) {
  customElements.define('vg-premium-edit', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vg-premium-edit__track');
      this.previous = this.querySelector('[data-edit-prev]');
      this.next = this.querySelector('[data-edit-next]');
      this.position = this.querySelector('[data-edit-position]');
      this.onScroll = () => this.update();
      this.onPrevious = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    move(direction) {
      const slide = this.track.querySelector('.vg-premium-edit__slide');
      const step = slide.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
      const count = Math.max(1, Math.floor(this.track.clientWidth / step));
      this.track.scrollBy({ left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    update() {
      const track = this.track;
      this.previous.disabled = track.scrollLeft <= 2;
      this.next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      const bounds = track.getBoundingClientRect();
      const slides = [...track.children];
      const visible = slides.map((slide, index) => ({ index, rect: slide.getBoundingClientRect() })).filter(({rect}) => rect.right > bounds.left + 10 && rect.left < bounds.right - 10);
      if (visible.length) {
        const text = `${visible[0].index + 1}–${visible[visible.length - 1].index + 1} / ${slides.length}`;
        if (this.position.textContent !== text) this.position.textContent = text;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.track?.removeEventListener('scroll', this.onScroll);
      this.previous?.removeEventListener('click', this.onPrevious);
      this.next?.removeEventListener('click', this.onNext);
    }
  });
}
